module.exports = __webpack_public_path__ + "img/mortgage.2153aaa9.svg";